import React, { useState, useEffect } from 'react';
import { Button, Form, Dropdown, Modal } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa';
import { GrAnnounce } from 'react-icons/gr';
import { TbListDetails } from 'react-icons/tb';
import './deptannouncements.css';
import { Link } from 'react-router-dom';
import { IoMdAddCircle } from "react-icons/io";
import axios from '../../Authservices/axiosInstance';
import moment from 'moment'; // Import moment to format dates

export default function DeptAnnouncements() {
  // State variables
  const [announcements, setAnnouncements] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [query, setQuery] = useState(''); // Search query state
  const [department, setDepartment] = useState(''); // Department filter state

  const rowsPerPage = 10;

  // Function to fetch all announcements based on search filters
  const fetchAnnouncements = async (searchQuery = '', department = '') => {
    try {
      const response = await axios.get('https://backend.ems.uk.hiradentallab.com/api/deptannouncements/search-all', {
        params: {
          query: searchQuery,  // Search query for title/message
          department,  // Department filter
        }
      });
      setAnnouncements(response.data); // Set the fetched announcements to state
    } catch (error) {
      console.error('Error fetching announcements:', error);
    }
  };

  // Fetch announcements when the component mounts or when the search query changes
  useEffect(() => {
    fetchAnnouncements(query, department);
  }, [query, department]);


  // Pagination logic
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const pageRange = () => {
    const totalPages = Math.ceil(announcements.length / rowsPerPage);
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  };

  const handleActionClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  // Handle search form submit without page reload
  const handleSearchSubmit = (e) => {
    e.preventDefault(); // Prevent page reload
    fetchAnnouncements(query, department);  // Fetch announcements with the search query and department filter
  };

  return (
    <div className='container-fluid'>
      <h1 className="announcement-title">
        <GrAnnounce className="salary-icon" /> Department Announcements
      </h1>
      <hr />
      <h2 className="announcement-subtitle">
        <TbListDetails className="salary-icon" /> All Department Announcements
      </h2>
      <hr />
      <div className="announcement-container">
        <Link to="/add-dept-announcements" style={{ textDecoration: "none" }}>
          <Button
            variant="primary"
            style={{ marginBottom: "15px", marginLeft: "-0.2%" }}
          >
            <IoMdAddCircle /> Add Announcements
          </Button>
        </Link>
        <div className="filter-container">
          <div className="filter-left">
            <Dropdown className="d-inline mx-0" autoClose="inside">
              <Dropdown.Toggle id="dropdown-autoclose-inside">
                Show Entries
              </Dropdown.Toggle>
              <Dropdown.Menu className="custom-dropdown-menu">
                <Dropdown.Item href="#">15</Dropdown.Item>
                <Dropdown.Item href="#">25</Dropdown.Item>
                <Dropdown.Item href="#">50</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="filter-right">
            <Form className="d-flex" onSubmit={handleSearchSubmit}>
            <Form.Control
                type="text"
                placeholder="Department"
                aria-label="Department"
                className="search-bar"
                value={department} // Controlled input for department filter
                onChange={(e) => setDepartment(e.target.value)} // Update department filter state
              />
            </Form>
          </div>
        </div>
        <div className="table-responsive">
          <table className="announcement-table">
            <thead className='dept-announcement-table-header'>
              <tr className="table-header">
                <th>SR</th>
                <th>DPT</th>
                <th>Title</th>
                <th>Created</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {announcements.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage).map((item, index) => (
                <tr key={index} className="table-row">
                  <td>{index + 1}</td>
                  <td>{item.department}</td> {/* Display department directly */}
                  <td>{item.title}</td>
                  <td>{moment(item.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</td> {/* Format the date */}
                  <td>
                    <Button
                      onClick={() => handleActionClick(item)}
                      title="View Details"
                      size='sm'
                    >
                      <FaEye />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot className='table-footer'>
              <tr className='depts-announcement-table-footer'>
                <td>Total</td>
                <td>-</td>
                <td>{announcements.length}</td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="pagination-container">
          <div>
            Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, announcements.length)} of {announcements.length} entries
          </div>
          <nav>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <a
                  href="/#"
                  className="page-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageChange(currentPage - 1);
                  }}
                >
                  Previous
                </a>
              </li>
              {pageRange().map(pageNumber => (
                <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                  <a
                    href="/#"
                    className="page-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(pageNumber);
                    }}
                  >
                    {pageNumber}
                  </a>
                </li>
              ))}
              <li className={`page-item ${currentPage === Math.ceil(announcements.length / rowsPerPage) ? 'disabled' : ''}`}>
                <a
                  href="/#"
                  className="page-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageChange(currentPage + 1);
                  }}
                >
                  Next
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      {/* Modal for displaying row details */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Details for {selectedItem?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Department: {selectedItem?.department}</p> {/* Display department directly */}
          <p>Title: {selectedItem?.title}</p>
          <p>Message: {selectedItem?.message}</p>
          <p>Created: {moment(selectedItem?.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</p> {/* Format date in modal */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
